module.exports = __webpack_public_path__ + "static/media/search-tick.fb3b2e1d.svg";